module.exports = __webpack_public_path__ + "static/media/Hero-Alamy.30c092b9.jpg";